import {styled} from '@vebox/etui-system';
import {Div, DivProps} from '@vebox/etui-system-elements';
import {Theme} from "@vebox/etui-themes";

export const AccordionSectionNameSpan = styled(Div).attrs(
    ({theme}: DivProps): DivProps => ({
        p: `${(theme as Theme).spacing.sm}px ${(theme as Theme).spacing.sm}px ${(theme as Theme).spacing.sm}px 0`,
    }),
)<DivProps>`
    flex-grow: 1;
    background-color: transparent;
    transition: 0.2s;
`;
